import styled from 'styled-components';
import { Button } from '@mui/material';
import { Icon } from 'components/ui';
import { useTranslation } from 'react-i18next';

const ImportButton = styled(({ onClick, ...props }) => {
  const { t } = useTranslation();

  return (
    <Button
      {...props}
      size="medium"
      variant="contained"
      onClick={onClick}
      startIcon={<Icon icon="download" size="1x" />}
    >
      {t('Import')}
    </Button>
  );
})`
  && {
    white-space: nowrap;
    background-color: inherit;
    min-width: auto;
    color: black;
    :hover {
      background-color: inherit;
    }
  }
`;

export default ImportButton;
